import FullInfoField from 'components/FullInfoField/FullInfoField';
import React, { useContext } from 'react';
import { useTranslation } from 'react-i18next';
import {
	IRestaurantFullInfoContext,
	RestaurantFullInfoContext,
} from '../../../../../../../restaurantFullInfoState/restaurantFullInfoContext';
import { reportType } from 'appConstants';

const ReportTypeField: React.FC = () => {
	const { report } = useContext<IRestaurantFullInfoContext>(RestaurantFullInfoContext);
	const { t } = useTranslation('form');

	const reportName = reportType.find((el) => el.reportTypeID === report?.reportType)?.reportTypeName;

	return <FullInfoField label="reportTypeLabel" value={t(reportName || '') as string} />;
};

export default ReportTypeField;
